/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import {WS_STATUS_UPDATE, WebsocketActions} from 'store/action/websocket';
import {IAppStore} from 'store';

export const websocketStatusSelector = (state: IAppStore): string => state.websocket.status;

export interface IWebsocketState {
  status: string;
}

export const initialConnection: IWebsocketState = {status: ''};

const webSocketReducer = (websocket: IWebsocketState = initialConnection, action: WebsocketActions): IWebsocketState => {
  switch (action.type) {
    case WS_STATUS_UPDATE:
      return Object.assign({}, websocket, {status: action.status});

    default:
      return websocket;
  }
};

export default webSocketReducer;